import { AssetEmailDto } from 'app/client-core/dtos/asset-email.model';
import { CreateTacticCategoryCommand, ProgramTacticComponent } from './../dtos/tactics.model';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';

import { ApiService } from "../api.service";
import { Bucket } from '../dtos/buckets.model';
import { Subject } from 'rxjs/Subject';
import { Router } from '@angular/router';
import {  CampaignThemeDto, CampaignThemeId, CampaignThemeTacticListItemDto } from '../dtos/campaigns.model';
import { BrandListItemDto } from '../dtos/brands.model';
import { ApiResponse, ApiPagedResponse } from '../api-response-models';
import { TacticCatalogSearch, TacticDto, TacticId, SaveProgramTacticCommand, ProductionOptionLookupItemDto, ProgramTacticId, DeliveryMethodLookupItemDto, ProgramTacticDto, ProgramTacticCartSummaryDto } from '../dtos/tactics.model';
import { ProgramId } from '../dtos/programs.model';
import { CustomizationDto, ProgramCustomizationDto } from '../dtos/customization.model';
import { TacticAssetslistItemDTO } from '../dtos/tactics.model';
import { TacticFinalizeDto, OrderStatusDetails } from '../dtos/finalize.model';
import { CostPerUnitDto } from '../dtos/cost.per-unit.model';
import { ProgramDetailsDto, ProgramDetailsTactic, ProgramDetailsTacticComponent } from '../dtos/program-details';

@Injectable()
export class TacticService {
    //event used to notify when campaign theme is saved, info is requested or theme is selected
    public campaignThemeSaved: Subject<CampaignThemeId>;
    public showCampaignThemeInfo: Subject<CampaignThemeId>;
    public selectTacticInfo: Subject<{id: TacticId, productType: number, programTacticId?: number}>;
    public selectProgramInfo: Subject<ProgramId>;
    public showTacticInfo: Subject<TacticId>;
    public newFavoriteAdded: Subject<TacticId>;
    public newTacticSearchModelArrived: Subject<TacticCatalogSearch>;
    public programTacticSaved: Subject<ProgramId>;
    public showProgramTacticCartDetails: Subject<ProgramId>;
    public editProgramTactic: Subject<ProgramTacticId>;
    public editNewProgramTactic: Subject<ProgramTacticId>;
    public editProgramTacticOrderStatus: Subject<OrderStatusDetails>;
    public customizeProgramTactics: Subject<ProgramId>;
    public finalizeProgramTactics: Subject<ProgramId>;
    public orderStatusSaved: Subject<any>;
    public tacticSaved: Subject<any>;
    public callFinalizeGoToNextSteps: Subject<boolean>;
    public programTacticCustomizationSaved: Subject<ProgramId>;
    public editProgramTacticCustomization: Subject<TacticFinalizeDto>;
    public tacticNextStepRequested: Subject<ProgramId>;
    public sendAssetEmail: Subject<{tacticId: number, link: string}>;
    public sendTacticAssetEmail: Subject<{tacticId: number, link: string, tacticName: string}>;
    public customizations: ProgramCustomizationDto[] = [];
    public programTacticEdited: Subject<any>;
    public programTacticAdded: Subject<{tactic: ProgramDetailsTactic, addNew: boolean}>;
    public updateComponentTactic: Subject<{tactic: ProgramDetailsTactic}>;
    public programTacticComponentEdited: Subject<any>;
    public promoCodeCreateEdited: Subject<any>;
    public biTacticNextStepRequested: Subject<ProgramId>;
    public componentSelected: Subject<{componentID: number, programTacticId: number}>
    public programTacticDeletede: Subject<any>;
    public tacticTypeIdChanged: Subject<any>;
    public programTacticComponentAddNew: Subject<any>;
    public updateProgramTacticId: Subject<number>;

    constructor(private apiService: ApiService,
       private router: Router) {
        this.campaignThemeSaved = new Subject<CampaignThemeId>();
        this.showCampaignThemeInfo = new Subject<CampaignThemeId>();
        this.selectTacticInfo = new Subject<{id: TacticId, productType: number}>();
        this.newFavoriteAdded = new Subject<TacticId>();
        this.newTacticSearchModelArrived = new Subject<TacticCatalogSearch>();
        this.selectProgramInfo = new Subject<ProgramId>();
        this.showTacticInfo = new Subject<TacticId>();
        this.programTacticSaved = new Subject<ProgramId>();
        this.showProgramTacticCartDetails = new Subject<ProgramId>();
        this.editProgramTactic = new Subject<ProgramTacticId>();
        this.editNewProgramTactic = new Subject<ProgramTacticId>();
        this.customizeProgramTactics = new Subject<ProgramId>();
        this.finalizeProgramTactics = new Subject<ProgramId>();
        this.orderStatusSaved = new Subject<any>();

        this.programTacticCustomizationSaved = new Subject<ProgramId>();
        this.editProgramTacticCustomization = new Subject<TacticFinalizeDto>();
        this.editProgramTacticOrderStatus = new Subject<OrderStatusDetails>();
        this.tacticNextStepRequested = new Subject<ProgramId>();
        this.biTacticNextStepRequested = new Subject<ProgramId>();
        this.tacticSaved = new Subject<any>();
        this.sendAssetEmail = new Subject<{tacticId: number, link: string}>();
        this.sendTacticAssetEmail = new Subject<{tacticId: number, link: string, tacticName: string}>();
        this.callFinalizeGoToNextSteps = new Subject<boolean>();
        this.programTacticEdited = new Subject<any>();
        this.promoCodeCreateEdited = new Subject<any>();
        this.componentSelected = new Subject<any>();
        this.programTacticComponentEdited = new Subject<any>();
        this.programTacticDeletede = new Subject<any>();
        this.programTacticAdded = new Subject<any>();
        this.updateComponentTactic = new Subject<any>();
        this.tacticTypeIdChanged = new Subject<any>();
        this.programTacticComponentAddNew = new Subject<any>();
        this.updateProgramTacticId = new Subject<any>();
    }

    /**
     * Returns lookup list of projects
     * @param params
     */
    getTactic(id: number): Observable<ApiResponse<TacticDto>> {
        console.log(`>>getTactic for ${id}`);
        return this.apiService.get<TacticDto>(`tactics/${id}`);
    }

    getCampaignThemeTactic(id: number): Observable<ApiResponse<ApiPagedResponse<CampaignThemeTacticListItemDto>>> {
        console.log(`>>getCampaignThemeTactic for ${id}`);
        return this.apiService.get<ApiPagedResponse<CampaignThemeTacticListItemDto>>(`campaigns/${id}/campaign-theme-tactics`);
    }

    getCampaignTheme(id: number): Observable<ApiResponse<CampaignThemeDto>> {
        console.log(`>>getCampaignTheme for ${id}`);
        return this.apiService.get<CampaignThemeDto>(`campaigns/${id}`);
    }

    getTacticsAssets(params?: any): Observable<ApiResponse<ApiPagedResponse<TacticAssetslistItemDTO>>> {
        console.log(`>>getCampaignThemeTacticsAssetsfor`, JSON.stringify(params));
        return this.apiService.get<ApiPagedResponse<TacticAssetslistItemDTO>>(`Tactics/Assets`, params);
    }

    getCampaignTacticsAssets(params?: any): Observable<ApiResponse<ApiPagedResponse<TacticAssetslistItemDTO>>> {
        console.log(`>>getCampaignThemeTacticsAssetsfor`, JSON.stringify(params));
        return this.apiService.get<ApiPagedResponse<TacticAssetslistItemDTO>>(`Tactics/campaign-assets`, params);
    }

    /**
     * Returns lookup list of projects
     * @param params
     */
    getProductionOptionsLookup(params?: any): Observable<ApiResponse<ApiPagedResponse<ProductionOptionLookupItemDto>>> {
        console.log('>>getProductionOptionsLookup', JSON.stringify(params));
        return this.apiService.get<ApiPagedResponse<ProductionOptionLookupItemDto>>('tactics/lookup/production-options', params);
    }

    getDeliveryMethodsLookup(params?: any): Observable<ApiResponse<ApiPagedResponse<DeliveryMethodLookupItemDto>>> {
        console.log('>>getDeliveryMethodLookupItemDto', JSON.stringify(params));
        return this.apiService.get<ApiPagedResponse<DeliveryMethodLookupItemDto>>(`tactics/lookup/delivery-methods`, params);
    }

    getBrandsLookup(params?: any): Observable<ApiResponse<ApiPagedResponse<BrandListItemDto>>> {
        console.log('>>getBrandsLookup', JSON.stringify(params));
        return this.apiService.get<ApiPagedResponse<BrandListItemDto>>('campaigns/lookup/brands', params);
    }

    createProgramTactic(command: SaveProgramTacticCommand): Observable<ApiResponse<ProgramTacticId>> {
        return this.apiService.post<ProgramTacticId>(`programtactics`, command);
    }

    updateProgramTactic(id: number, command: SaveProgramTacticCommand): Observable<ApiResponse<ProgramTacticId>> {
        return this.apiService.post<ProgramTacticId>(`programtactics/${id}`, command);
    }

    deleteProgramTactic(id: number): Observable<ApiResponse<ProgramTacticId>> {
        return this.apiService.delete<ProgramTacticId>(`programtactics/${id}`);
    }

    getProgramTactic(id: number): Observable<ApiResponse<ProgramTacticDto>> {
        console.log(`>>getProgramTactic for ${id}`);
        return this.apiService.get<ProgramTacticDto>(`programtactics/${id}`);
    }

    getProgramTactics(id: number): Observable<ApiResponse<any>> {
        console.log(`>>GetProgramTacticList for ${id}`);
        return this.apiService.get<any>(`programs/${id}/tactics`);
    }

    getCartProgramTactics(id: number): Observable<ApiResponse<Array<any>>> {
        console.log(`>>GetProgramTacticList for ${id}`);
        return this.apiService.get<Array<any>>(`programs/${id}/cart-tactics`);
    }

    getProgramTacticCartSummary(id: number): Observable<ApiResponse<ProgramTacticCartSummaryDto>> {
        console.log(`>>getProgramTacticCartSummary for ${id}`);
        return this.apiService.get<ProgramTacticCartSummaryDto>(`programs/${id}/tacticcartsummary`);
    }

    getGlobalTacticCustomization(id: ProgramId): Observable<ApiResponse<ApiPagedResponse<ProgramCustomizationDto>>> {
        console.log(`>>getGlobalTacticCustomization for ${id}`);
        return this.apiService.get<ApiPagedResponse<ProgramCustomizationDto>>(`customizationtactic/${id.value}`);
    }

    private remapCustomizationIdAndEntry(dto: ApiResponse<ApiPagedResponse<ProgramCustomizationDto>>) {
        //since the data is not in conventation format, and put is expecting things that are not supplied in get
        //do some mapping
        console.log('remapping for non conventional PUT');
        if (dto && dto.data && dto.data.items) {
            dto.data.items.forEach((item) => {
                item.customizationRequest.forEach((cust) => {
                    if (cust.customizationRequestUIElementId == 1 && cust.customizationEntryId) {
                        let index = cust.customizationDisplayOption.findIndex((opt) => {
                            return opt.id == cust.customizationEntryId;
                        });

                        if (index >= 0) {
                            cust.customizationEntry = cust.customizationDisplayOption[index].customizationDisplayOptionName;
                        }
                    } else if ((cust.customizationRequestUIElementId == 2 || cust.customizationRequestUIElementId == 3) &&
                        cust.customizationEntry && cust.customizationDisplayOptionCount > 0) {
                        cust.customizationEntryId = cust.customizationDisplayOption[0].id;
                    }
                });
            });
        }
    }
    saveGlobalTacticCustomization(id: ProgramId, dto: ApiResponse<ApiPagedResponse<ProgramCustomizationDto>>): Observable<ApiResponse<ProgramTacticId>> {
        this.remapCustomizationIdAndEntry(dto);
        return this.apiService.put<ProgramTacticId>(`customizationtactic/${id.value}`, dto);
    }

    getProgramTacticCustomization(id: ProgramId): Observable<ApiResponse<ApiPagedResponse<ProgramCustomizationDto>>> {
        console.log(`>>getProgramTacticCustomization for ${id}`);
        return this.apiService.get<ApiPagedResponse<ProgramCustomizationDto>>(`customizationtactics/${id.value}`);
    }

    saveProgramTacticCustomizations(id: number, dto: ApiResponse<ApiPagedResponse<ProgramCustomizationDto>>): Observable<ApiResponse<ProgramTacticId>> {
        this.remapCustomizationIdAndEntry(dto);
        return this.apiService.put<ProgramTacticId>(`customizationtactics/${id}`, dto);
    }

    saveProductionProgramTacticCustomizations(id: number, dto: ApiResponse<ApiPagedResponse<ProgramCustomizationDto>>): Observable<ApiResponse<ProgramTacticId>> {
        this.remapCustomizationIdAndEntry(dto);
        return this.apiService.put<ProgramTacticId>(`customtacticproduction/${id}`, dto);
    }

    getProgramTacticFinalization(id: ProgramId): Observable<ApiResponse<Array<any>>> {
        console.log(`>>getProgramTacticFinalization for ${id}`);
        return this.apiService.get<Array<any>>(`programs/${id.value}/tactics/final`);
    }

    getAllTactics(params?: any): Observable<ApiResponse<ApiPagedResponse<TacticDto>>> {
        console.log(`>>GetAllTacticsList`);
        return this.apiService.get<ApiPagedResponse<TacticDto>>(`tactics/all`, params);
    }

    getDocumentTypes(params?: any): Observable<ApiResponse<ApiPagedResponse<any>>> {
        return this.apiService.get<ApiPagedResponse<TacticDto>>(`tactics/lookup/documenttypes`, params);
    }

    getOutputTypes(params?: any): Observable<ApiResponse<ApiPagedResponse<any>>> {
        return this.apiService.get<ApiPagedResponse<TacticDto>>(`tactics/lookup/outputtypes`, params);
    }

    getProductOptions(params?: any): Observable<ApiResponse<ApiPagedResponse<any>>> {
        return this.apiService.get<ApiPagedResponse<TacticDto>>(`tactics/lookup/productionoptions`, params);
    }

    getProductTypes(params?: any): Observable<ApiResponse<ApiPagedResponse<any>>> {
        return this.apiService.get<ApiPagedResponse<TacticDto>>(`tactics/lookup/producttypes`, params);
    }

    getProductionProcessing(params?: any): Observable<ApiResponse<ApiPagedResponse<any>>> {
        return this.apiService.get<ApiPagedResponse<TacticDto>>(`tactics/lookup/productionprocessing`, params);
    }

    getManufacturers(params?: any): Observable<ApiResponse<ApiPagedResponse<any>>> {
        return this.apiService.get<ApiPagedResponse<TacticDto>>(`tactics/lookup/manufacturer`, params);
    }

    saveTactic(dto: TacticDto): Observable<ApiResponse<ProgramTacticId>> {
        if (dto.id) {
            return this.apiService.put<ProgramTacticId>(`tactics`, dto);
        } else {
            return this.apiService.post<ProgramTacticId>(`tactics`, dto);
        }
    }

    getTacticToEdit(id: number): Observable<ApiResponse<TacticDto>> {
        console.log(`>>getTactic for ${id}`);
        return this.apiService.get<TacticDto>(`tactics/edit/${id}`);
    }

    getOrderStatusDetails(id: ProgramId): Observable<ApiResponse<ApiPagedResponse<ProgramCustomizationDto>>> {
        console.log(`>>getProgramTacticCustomization for ${id}`);
        return this.apiService.get<ApiPagedResponse<ProgramCustomizationDto>>(`customizationtactics/${id.value}`);
    }

    getOrderStatus(): Observable<ApiResponse<any>> {
        return this.apiService.get<ApiPagedResponse<any>>(`tactics/lookup/status`);
    }

    saveOrderStatus(dto: OrderStatusDetails): Observable<ApiResponse<any>> {
        return this.apiService.put<ApiPagedResponse<any>>(`tactics/orderstatus`, dto);
    }

    getTacticCategories(params?): Observable<ApiResponse<any>> {
        return this.apiService.get<ApiPagedResponse<any>>(`tactics/tacticcategory`, params);
    }

    getCampaigns(params?: any): Observable<ApiResponse<any>> {
        return this.apiService.get<ApiPagedResponse<any>>(`campaigns/lookup/campaignthemes`, params);
    }

    getCategory(params?: any): Observable<ApiResponse<any>> {
        return this.apiService.get<ApiPagedResponse<any>>(`tactics/lookup/tacticcategory`, params);
    }

    createTacticCategory(command: CreateTacticCategoryCommand): Observable<ApiResponse<number>> {
        return this.apiService.post<number>(`tactics/tacticcategory`, command);
    }

    saveCostPerUnit(dto: CostPerUnitDto): Observable<ApiResponse<ProgramTacticId>> {
        return this.apiService.post<ProgramTacticId>(`tactics/save-unit-cost`, dto);
    }

    getAllUnitPerCost(tacticid: number): Observable<ApiResponse<Array<CostPerUnitDto>>> {
        return this.apiService.get<Array<CostPerUnitDto>>(`tactics/${tacticid}/unit-cost`);
    }

    getUnitPerCost(id: number): Observable<ApiResponse<ApiPagedResponse<CostPerUnitDto>>> {
        return this.apiService.get<ApiPagedResponse<CostPerUnitDto>>(`tactics/unit-cost/${id}`);
    }

    deleteUnitPerCost(id: number): Observable<ApiResponse<ApiPagedResponse<boolean>>> {
        return this.apiService.delete<ApiPagedResponse<boolean>>(`tactics/unit-cost/${id}`);
    }

    validateSku(sku: string, tacticId?: number): Observable<any> {
        return this.apiService.get<any>(`tactics/validate-sku?sku=${sku}&tacticId=${tacticId}`);
    }

    sendAssetLinkEmail(model: AssetEmailDto): Observable<any> {
        return this.apiService.post<any>(`tactics/send-asset-link-email`, model);
    }

    getRecommendedCustomizationOptionId(id: number, displayOptionIds: Array<number>): Observable<ApiResponse<any>> {
        console.log(`>>getProgramTactic for ${id}`);
        // tslint:disable-next-line:max-line-length
        return this.apiService.get<ProgramTacticDto>(`customizationrequest/recommended-customization?programId=${id}&customizationOptionIds=${displayOptionIds.join('&customizationOptionIds=')}`);
    }

    getRecommendedAccountLocations(id: number, displayOptionIds: Array<number>): Observable<ApiResponse<any>> {
        console.log(`>>getProgramTactic for ${id}`);
        // tslint:disable-next-line:max-line-length
        return this.apiService.get<ProgramTacticDto>(`customizationrequest/recommended-account-location?programId=${id}&customizationOptionIds=${displayOptionIds.join('&customizationOptionIds=')}`);
    }

    getDataPoint(id: number): Observable<ApiResponse<any>> {
        console.log(`>>getProgramTactic for ${id}`);
        return this.apiService.get<ProgramTacticDto>(`customizationrequest/datapoint/${id}`);
    }

    getShopTypes(params?: any): Observable<ApiResponse<ApiPagedResponse<any>>> {
        return this.apiService.get<ApiPagedResponse<TacticDto>>(`tactics/lookup/shop-types`, params);
    }

    getTacticTypes(params?: any): Observable<ApiResponse<ApiPagedResponse<any>>> {
        return this.apiService.get<ApiPagedResponse<TacticDto>>(`tactics/lookup/tactics`, params);
    }

    saveProgramTactic(model: ProgramDetailsTactic): Observable<any> {
        return this.apiService.post<any>(`tactics/save-program-tactic`, model);
    }

    getComponentToEdit(id: number, params?: any): Observable<ApiResponse<ProgramTacticComponent>> {
        return this.apiService.get<ProgramTacticComponent>(`programtactics/component/${id}`, params);
    }

    getComponentFiles(id: number, params?: any): Observable<ApiResponse<Array<any>>> {
        return this.apiService.get<Array<any>>(`programtactics/component-files/${id}`, params);
    }

    getVendors(params?: any): Observable<ApiResponse<any>> {
        return this.apiService.get<any>(`programtactics/lookup/vendor`, params);
    }

    getVendorsPaged(params?: any): Observable<ApiResponse<any>> {
        return this.apiService.get<any>(`programtactics/lookup/vendors-paged`, params);
    }

    getVendorsChildPaged(params?: any): Observable<ApiResponse<any>> {
        return this.apiService.get<any>(`programtactics/lookup/vendors-child-paged`, params);
    }

    getVendorsChild(vendorId: number): Observable<ApiResponse<any[]>> {
        return this.apiService.get<any[]>(`vendors/child/${vendorId}`);
    }

    getBarcodeDestination(params?: any): Observable<ApiResponse<any>> {
        return this.apiService.get<any>(`programtactics/lookup/barcode-destination`, params);
    }

    getMediaTypes(params?: any): Observable<ApiResponse<any>> {
        return this.apiService.get<any>(`programtactics/lookup/media-type`, params);
    }

    getComponentTypes(params?: any): Observable<ApiResponse<any>> {
        return this.apiService.get<any>(`programtactics/lookup/component-type`, params);
    }

    saveComponent(model: ProgramTacticComponent): Observable<any> {
        return this.apiService.post<any>(`programtactics/component`, model);
    }

    lookupParentTactic(params?: any): Observable<ApiResponse<ApiPagedResponse<ProductionOptionLookupItemDto>>> {
        console.log('>>getProductionOptionsLookup', JSON.stringify(params));
        return this.apiService.get<ApiPagedResponse<ProductionOptionLookupItemDto>>('tactics/lookup/parent-tactics', params);
    }

    sendFilesToProduction(id: number): Observable<ApiResponse<boolean>> {
        console.log(`>>getProgramTacticCustomization for ${id}`);
        return this.apiService.put<boolean>(`programs/${id}/set-send-production`, {});
    }

    lookupChildTactic(params?: any): Observable<ApiResponse<ApiPagedResponse<ProductionOptionLookupItemDto>>> {
        console.log('>>getProductionOptionsLookup', JSON.stringify(params));
        return this.apiService.get<ApiPagedResponse<ProductionOptionLookupItemDto>>('tactics/lookup/child-tactics', params);
    }

    deleteFile(key) {
        return this.apiService.post<any>('programtactics/component/deleteFile', {
            key
        });
    }

    deleteTacticFile(id, key) {
        return this.apiService.post<any>(`tactics/${id}/deleteFile`, {
            key
        });
    }

    getFiles(id: number): Observable<ApiResponse<any>> {
        console.log(`>>getProgramTacticCustomization for ${id}`);
        return this.apiService.get<any>(`tactics/${id}/files`, {});
    }

    checkCanDeleteProgramTactic(id: number): Observable<ApiResponse<{programId: number, canDelete: string}>> {
        return this.apiService.get<{programId: number, canDelete: string}>(`programtactics/check-candelete/${id}`, {});
    }

    deleteProgramTacticFromDatabase(id): Observable<ApiResponse<boolean>> {
        return this.apiService.post<boolean>(`programtactics/delete/${id}`, {});
    }

    checkCanDeleteProgramTacticComponent(id: number): Observable<ApiResponse<{programId: number, canDelete: string}>> {
        return this.apiService.get<{programId: number, canDelete: string}>(`programtactics/check-candelete-component/${id}`, {});
    }

    deleteProgramTacticComponent(id): Observable<ApiResponse<boolean>> {
        return this.apiService.post<boolean>(`programtactics/delete-component/${id}`, {});
    }

    getComponentFundings(params?: any): Observable<ApiResponse<any>> {
        return this.apiService.get<any>(`programs/component-fundings`, params);
    }

    logUserTacticDownload(ids): Observable<any> {
        return this.apiService.post<any>(`tactics/log-asset-download?id=${ids}`, null);
    }
}



// WEBPACK FOOTER //
// ./src/app/client-core/services/tactic.service.ts